import Image from "next/image";
import Link from "next/link";
import type { SiteTemplateKey } from "@/lib/siteTemplates";

export function CtaBannerBlock({
  content,
  template = "classic",
}: {
  content: Record<string, unknown>;
  template?: SiteTemplateKey;
}) {
  const heading = String(content.heading ?? "");
  const body = String(content.body ?? "");
  const buttonText = content.buttonText ? String(content.buttonText) : null;
  const buttonUrl = content.buttonUrl ? String(content.buttonUrl) : null;
  const backgroundImage = content.backgroundImage ? String(content.backgroundImage) : null;
  const objectPosition = content.objectPosition ? String(content.objectPosition) : "center center";
  const overlay = Boolean(content.overlay);
  const textAlignment = String(content.textAlignment ?? "center") as "left" | "center" | "right";

  if (!heading && !body) return null;

  const alignClass = textAlignment === "left" ? "items-start text-left" : textAlignment === "right" ? "items-end text-right" : "items-center text-center";

  return (
    <section data-template={template} className="relative overflow-hidden py-[calc(var(--space-unit)*4)] md:py-[calc(var(--space-unit)*6)]">
      {backgroundImage && (
        <Image
          src={backgroundImage}
          alt=""
          fill
          className="object-cover"
          style={{ objectPosition }}
          sizes="100vw"
          priority
        />
      )}
      {overlay && <div className="absolute inset-0 bg-[var(--color-text)]/70" />}
      <div className={`relative mx-auto flex max-w-4xl flex-col gap-[calc(var(--space-unit)*1)] px-4 ${alignClass}`}>
        {heading && (
          <h2
            className={`font-bold ${backgroundImage && overlay ? "text-white" : "text-[var(--color-text)]"}`}
            style={{ fontFamily: "var(--font-heading)", fontSize: "var(--text-h1)", lineHeight: "var(--line-heading)" }}
          >
            {heading}
          </h2>
        )}
        {body && (
          <p className={`max-w-2xl text-lg ${backgroundImage && overlay ? "text-white/90" : "text-[rgb(var(--color-secondary))]"}`}>
            {body}
          </p>
        )}
        {buttonText && buttonUrl && (
          <Link
            href={buttonUrl}
            className="mt-2 inline-flex min-h-[44px] w-fit items-center justify-center rounded-[var(--border-radius)] bg-[rgb(var(--color-primary))] px-6 py-2 text-sm font-medium text-white hover:opacity-90"
          >
            {buttonText}
          </Link>
        )}
      </div>
    </section>
  );
}
